export class PrizeModel {
    id = Number;
    gamePrizeID = Number;
    uid = String;
    image = new Image();
    videoSrc = "";

    constructor(params = {
        id: -1,
        uid: "",
        booby: false
    }) {
        this.id = params.id;
        this.uid = params.uid;
        this.image.src = `https://app.tokaly.com/TokalyServer/api/Play/Tokaly/Prize/GetMediaByPrize?prizeUID=${params.uid}&type=IMAGE`;

        if(params.booby) {
            this.image.src = 'assets/images/booby.png'
        }

        this.videoSrc = `https://app.tokaly.com/TokalyServer/api/Play/Tokaly/Prize/GetMediaByPrize?prizeUID=${params.uid}&type=VIDEO`

        if(params.booby) {
            this.videoSrc = 'assets/images/Boobie Trap Loop.webm'
        }
    }
}